import { getAxiosClient } from '../../api';
import _ from 'lodash';

export const fetchDelegantiByServizio = async (
  servizioId,
  forceFetch = false
) => {
  const httpClient = await getAxiosClient();

  const cacheKey = `deleganti.${servizioId}`;
  const hasCache = _.has(window.editorLoader, cacheKey);

  if (!forceFetch && hasCache) {
    return _.get(window.editorLoader, cacheKey);
  }

  const params = {
    filterEqual_defunto_pointer: servizioId,
  };

  const response = await httpClient.get(
    `${process.env.PARSE_API_URL}/famigliari`,
    { params }
  );

  _.set(window.editorLoader, cacheKey, response.data.data);

  return response.data.data;
};
